function injectStyle (ssrContext) {
  require("!!../../../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-a72c652c\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TestsBlock.vue")
}
var Component = require("!../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TestsBlock.vue"),
  /* template */
  require("!!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a72c652c\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TestsBlock.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a72c652c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/components/info/components/block/components/legend/components/testsblock/TestsBlock.vue
// module id = df018bae3274227553e9
// module chunks = 89